module.exports = __webpack_public_path__ + "static/media/logoRedWhite.0e970fd0.webp";